import { useContext } from "react";

import AuthContext from "context/auth/authContext";
import { isAuthenticatorType } from "shared/functions";

import ContactUs from "./ContactUs";
import Recovery from "./Recovery";
import { SecondaryTextProps } from "./types";
import Verification from "./Verification";

const SecondaryText = ({ isRecoveryCodePhase }: SecondaryTextProps) => {
    const { is2FaVerification, authType } = useContext(AuthContext);

    if (is2FaVerification) {
        return isRecoveryCodePhase ? (
            <Recovery />
        ) : (
            <Verification isAuthenticatorType={isAuthenticatorType(authType)} />
        );
    }

    return <ContactUs />;
};

export default SecondaryText;
